module.exports = __webpack_public_path__ + "static/media/cohort_announcement.5ff94392.svg";